// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7d145ffd","845":"cf9648c3"}[chunkId] + ".chunk.js";
};